// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as StockActivityPage from "./StockActivityPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityRoutes from "./StockActivityRoutes.res.js";

function StockActivityRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  if (Auth.isAuthorizedAccess(userRole, StockActivityRoutes.baseRoute)) {
    if (subUrlPath !== 0 && (subUrlPath.hd !== "" || subUrlPath.tl !== 0)) {
      return JsxRuntime.jsx(Navigation.Redirect.make, {
        route: StockActivityRoutes.baseRoute
      });
    } else {
      return JsxRuntime.jsx(StockActivityPage.make, {});
    }
  } else {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
}

let make = React.memo(StockActivityRouter);

export {
  make,
}
/* make Not a pure module */
